export { hasPrimarySetupFeeLine, nestSetupFees } from '@repo/lib';

/** The sub-line for a setup fee line, as the confirmation email words it. */
export const setupFeeSubLine = (fee, money) => ({
  label: fee.quantity > 1 ? `Setup fee × ${fee.quantity}` : 'Setup fee',
  amount: money(fee.amount),
});
